import { render, staticRenderFns } from "./SelectDocument.vue?vue&type=template&id=670df0d0&scoped=true"
import script from "./SelectDocument.vue?vue&type=script&lang=js"
export * from "./SelectDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670df0d0",
  null
  
)

export default component.exports